<div class="container-fluid p-0" *ngIf="transportFormGroup">
  <jhi-bary-card titleKey="BARY_LIGHT_ESTIMATE.TITLE" class="bary-light-estimate">
    <div body>
      <section id="section-addresses">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col">
                <jhi-bary-input-gplace
                  [addressForm]="transportFormGroup.controls.pickupAddress"
                  id="pickupAddressAutofill"
                  [label]="'LABEL.PICKUP_ADDRESS' | translate"
                  [hidden]="false"
                  [verify]="false"
                  data-id-cypress="pickup-address"
                ></jhi-bary-input-gplace>
              </div>
              <div class="col-auto align-self-center">
                <jhi-bary-button
                  icon="star"
                  [outline]="true"
                  size="sm"
                  [label]="'LABEL.MY_ADDRESSES' | translate"
                  class="d-none d-lg-block"
                  (clickEvent)="openUseRegisteredAddress(true)"
                ></jhi-bary-button>
                <jhi-bary-icon-button
                  color="warning"
                  size="sm"
                  icon="star"
                  [outline]="true"
                  class="d-block d-lg-none"
                  (clickEvent)="openUseRegisteredAddress(true)"
                ></jhi-bary-icon-button>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col">
                <jhi-bary-input-gplace
                  [addressForm]="transportFormGroup.controls.deliveryAddress"
                  id="deliveryAddressAutofill"
                  [label]="'LABEL.DELIVERY_ADDRESS' | translate"
                  [hidden]="false"
                  data-id-cypress="delivery-address"
                  [verify]="false"
                >
                </jhi-bary-input-gplace>
              </div>
              <div class="col-auto align-self-center">
                <jhi-bary-button
                  icon="star"
                  [outline]="true"
                  size="sm"
                  [label]="'LABEL.MY_ADDRESSES' | translate"
                  class="d-none d-lg-block"
                  (clickEvent)="openUseRegisteredAddress(false)"
                ></jhi-bary-button>
                <jhi-bary-icon-button
                  color="warning"
                  size="sm"
                  icon="star"
                  [outline]="true"
                  class="d-block d-lg-none"
                  (clickEvent)="openUseRegisteredAddress(false)"
                ></jhi-bary-icon-button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="section-merchandises">
        <div class="row mb-1">
          <div class="col-12" *ngFor="let transportItemForm of transportFormGroup.controls.items; let isLast = last; let index = index">
            <jhi-bary-transport-item-line
              [transportFormGroup]="transportFormGroup"
              [item]="getValueForTransportItem(transportItemForm)"
              (deleteEvent)="handleRemove(index)"
              (editEvent)="initTransportItem(index)"
            ></jhi-bary-transport-item-line>
            <hr class="bary-hr" *ngIf="!isLast" />
          </div>
        </div>
        <div class="row" *ngIf="transportFormGroup.showAddItem()">
          <div class="col-12">
            <jhi-bary-specific-button class="col-12" type="addMerchandise" (clickEvent)="initTransportItem()"></jhi-bary-specific-button>
          </div>
        </div>
      </section>
      <section id="section-offer" #card>
        <div *ngIf="!loadingData && quotationOK && offerEstimations.length === 0" class="text-center pb-3 my-5">
          <hr class="bary-hr" />
          <p jhiTranslate="BARY_LIGHT_ESTIMATE.LABEL.NO_OFFERS"></p>
        </div>

        <div id="pricing" class="pb-3 my-1" *ngIf="!loadingData && quotationOK && offerEstimations.length > 0">
          <hr class="bary-hr" />
          <jhi-bary-title titleKey="BARY_LIGHT_ESTIMATE.LABEL.FIND_OFFERS"></jhi-bary-title>

          <div class="row justify-content-center" *ngIf="displayOfferMode === DisplayOfferModeEnum.VALID">
            <div class="col-12 col-md-6 col-lg-4 d-flex justify-content-center mb-4" *ngFor="let offerEstimation of offerEstimations">
              <jhi-bary-pricing-pack [offerEstimation]="offerEstimation" (estimateEvent)="chooseOffer($event, false)"></jhi-bary-pricing-pack>
            </div>
          </div>
          <div class="row justify-content-center" *ngIf="displayOfferMode === DisplayOfferModeEnum.VALID && quotationEstimation">
            <div class="col-12 col-md-6 col-lg-4">
              <jhi-bary-pricing-pack [offerEstimation]="quotationEstimation" (estimateEvent)="chooseOffer($event, false)"></jhi-bary-pricing-pack>
            </div>
          </div>
        </div>

        <div
          *ngIf="displayOfferMode === DisplayOfferModeEnum.VALID_AND_WITHOUT_CONSTRAINTS || displayOfferMode === DisplayOfferModeEnum.QUOTATION_AND_WITHOUT_CONSTRAINTS"
          class="row"
        >
          <div class="d-flex col-12 flex-md-row flex-column align-items-stretch justify-content-around flex-wrap" id="pricing-container">
            <ng-container *ngIf="displayOfferMode === DisplayOfferModeEnum.VALID_AND_WITHOUT_CONSTRAINTS">
              <ng-container *ngFor="let offerEstimation of offerEstimations">
                <jhi-bary-pricing-pack
                  class="d-block offer-valid m-2"
                  [offerEstimation]="offerEstimation"
                  (estimateEvent)="chooseOffer(offerEstimation, false)"
                  #pricingPack
                ></jhi-bary-pricing-pack>
              </ng-container>
            </ng-container>

            <ng-container *ngFor="let withoutConstraintsOfferEstimation of withoutConstraintsOfferEstimations; index as i">
              <div class="m-2 d-flex flex-column">
                <div class="alert alert-warning pb-1 mb-1" id="alert{{ i }}">
                  <div>{{ 'BARY_LIGHT_ESTIMATE.LABEL.FIND_OFFERS_WITHOUT_CONSTRAINTS' | translate }}&nbsp;:</div>
                  <ul class="mb-0" *ngFor="let constraint of withoutConstraintsOfferEstimation.constraints">
                    <li
                      *ngIf="constraint.params; else sans_params"
                      jhiTranslate="BARY_LIGHT_ESTIMATE.CONSTRAINT.MESSAGE.{{ constraint.type | uppercase }}"
                      [translateValues]="{ start: getStartHour(constraint), end: getEndHour(constraint) }"
                    ></li>
                    <ng-template #sans_params>
                      <li jhiTranslate="BARY_LIGHT_ESTIMATE.CONSTRAINT.MESSAGE.{{ constraint.type | uppercase }}"></li>
                    </ng-template>
                  </ul>
                </div>
                <jhi-bary-pricing-pack
                  [offerEstimation]="withoutConstraintsOfferEstimation"
                  (estimateEvent)="chooseOffer(withoutConstraintsOfferEstimation, true)"
                ></jhi-bary-pricing-pack>
              </div>
            </ng-container>
            <ng-container *ngIf="displayOfferMode === DisplayOfferModeEnum.QUOTATION_AND_WITHOUT_CONSTRAINTS && quotationEstimation">
              <div class="m-2 d-flex flex-column">
                <div jhiTranslate="BARY_LIGHT_ESTIMATE.LABEL.QUOTATION_ESTIMATION" class="alert alert-info pb-1 mb-1" id="quotation-alert"></div>
                <jhi-bary-pricing-pack [offerEstimation]="quotationEstimation" (estimateEvent)="chooseOffer(quotationEstimation, false)"></jhi-bary-pricing-pack>
              </div>
            </ng-container>
          </div>
        </div>
      </section>
    </div>
  </jhi-bary-card>
</div>
